import { Skeleton, TableRow, TableBody } from "@mui/material";

import { ActionLink } from "@/Actions/components/action/ActionLink";
import { RobotoTableCell, RobotoTableRow } from "@/shared/components";

interface PerActionStats {
  action_org_id: string;
  action_name: string;
  fail_count: number;
  queued_count: number;
  completed_count: number;
}

interface PerActionStatsTableBodyProps {
  isLoading: boolean;
  stats: PerActionStats[];
  sortStats: (stats: PerActionStats[]) => PerActionStats[];
  getSuccessRate: (stat: PerActionStats) => number | null;
}

export function PerActionStatsTableBody({
  isLoading,
  stats,
  sortStats,
  getSuccessRate,
}: PerActionStatsTableBodyProps) {
  if (isLoading) {
    return (
      <TableBody>
        {Array.from({ length: 5 }, (_, i) => (
          <TableRow key={`row-${i}`}>
            {Array.from({ length: 5 }, (_, j) => (
              <RobotoTableCell key={`cell-${j}`}>
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  height={30}
                  sx={{ mt: 1, mb: 1 }}
                />
              </RobotoTableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    );
  }

  if (stats.length > 0) {
    return (
      <TableBody>
        {sortStats(stats).map((stat, index) => {
          const successRateValue = getSuccessRate(stat);

          const successRateDisplay =
            successRateValue !== null
              ? `${(successRateValue * 100).toFixed(1)}%`
              : "N/A";
          return (
            <RobotoTableRow
              key={`${stat.action_org_id}-${stat.action_name}-${index}`}
            >
              <RobotoTableCell>
                <ActionLink
                  action={{
                    name: stat.action_name,
                    org_id: stat.action_org_id,
                  }}
                />
              </RobotoTableCell>
              <RobotoTableCell align="right">
                {stat.queued_count}
              </RobotoTableCell>
              <RobotoTableCell align="right">
                {stat.completed_count}
              </RobotoTableCell>
              <RobotoTableCell align="right">{stat.fail_count}</RobotoTableCell>
              <RobotoTableCell align="right">
                {successRateDisplay}
              </RobotoTableCell>
            </RobotoTableRow>
          );
        })}
      </TableBody>
    );
  }

  return (
    <TableBody>
      <TableRow>
        <RobotoTableCell colSpan={5} align="center">
          No data available for the selected time range
        </RobotoTableCell>
      </TableRow>
    </TableBody>
  );
}
